module.exports = __webpack_public_path__ + "img/DAVID_CANNON_12-rs.54dd9310.jpg";